module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-24-d4c2bf1fbff400c905696ea9a4a141ce.svg";